import React, { useState, useEffect } from 'react';
import './RoboticsLab.css';

// Import images for Robotics Lab
import robotics1 from '../assets/AI (1).webp';
import robotics2 from  '../assets/AI (3).webp';
import robotics3 from  '../assets/AI (2).webp';
import robotics4 from  '../assets/AI (4).webp';

const RoboticsLab = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const roboticsImages = [robotics1, robotics2, robotics3, robotics4];

  useEffect(() => {
    setIsVisible(true);
    
    // Auto-slide images every 3 seconds
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === roboticsImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? roboticsImages.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === roboticsImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="roboticslab-container">
         {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>AI AND ROBOTICS LAB</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>AI and Robotics Lab</li>
          </ul>
        </div>
      </section>

      {/* Main Content */}
      <div className="roboticslab-main-content">
        <div className="roboticslab-content-wrapper">
          {/* Left Side - Text Content */}
          <div className={`roboticslab-text-content ${isVisible ? 'roboticslab-visible' : ''}`}>
            <h2 className="roboticslab-main-heading">AI AND ROBOTICS LAB</h2>
            
            <p className="roboticslab-intro-text">
              At Bihani Children's Academy, we are proud to offer a state-of-the-art AI and Robotics Lab, 
              where innovation meets education. Our lab is designed to immerse students in the exciting world 
              of artificial intelligence and robotics, providing them with hands-on experience in the 
              technologies that are shaping the future.
            </p>

            <div className="roboticslab-feature">
              <h3 className="roboticslab-feature-title">Cutting-Edge Technology:</h3>
              <p className="roboticslab-feature-text">
                The lab is equipped with advanced robotics kits, AI development platforms, and the latest 
                tools to help students design, build, and program robots.
              </p>
            </div>

            <div className="roboticslab-feature">
              <h3 className="roboticslab-feature-title">Comprehensive Curriculum:</h3>
              <p className="roboticslab-feature-text">
                Our AI and Robotics curriculum covers essential topics such as machine learning, computer 
                vision, natural language processing, and automation. Students learn the fundamentals of AI 
                and robotics while engaging in practical projects that bring these concepts to life.
              </p>
            </div>

            <div className="roboticslab-feature">
              <h3 className="roboticslab-feature-title">Hands-On Learning:</h3>
              <p className="roboticslab-feature-text">
                The lab emphasizes experiential learning, allowing students to apply theoretical knowledge 
                to real-world problems. From building autonomous robots to developing AI models, students 
                gain practical skills that are critical in today's tech landscape.
              </p>
            </div>
          </div>

          {/* Right Side - Image Slider */}
          <div className={`roboticslab-image-slider ${isVisible ? 'roboticslab-visible' : ''}`}>
            <div className="roboticslab-slider-container">
              {roboticsImages.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Robotics Lab ${index + 1}`}
                  className={`roboticslab-slider-image ${
                    index === currentImageIndex ? 'roboticslab-active' : ''
                  }`}
                />
              ))}
              
              <button 
                className="roboticslab-slider-arrow roboticslab-arrow-left"
                onClick={handlePrevImage}
              >
                ‹
              </button>
              <button 
                className="roboticslab-slider-arrow roboticslab-arrow-right"
                onClick={handleNextImage}
              >
                ›
              </button>
              
              <div className="roboticslab-slider-dots">
                {roboticsImages.map((_, index) => (
                  <span
                    key={index}
                    className={`roboticslab-dot ${
                      index === currentImageIndex ? 'roboticslab-dot-active' : ''
                    }`}
                    onClick={() => handleDotClick(index)}
                  ></span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Additional Features Section */}
        <div className={`roboticslab-additional-section ${isVisible ? 'roboticslab-visible' : ''}`}>
          <div className="roboticslab-feature">
            <h3 className="roboticslab-feature-title">Collaborative Projects:</h3>
            <p className="roboticslab-feature-text">
              Students work in teams to design and execute projects, fostering collaboration, problem-solving, 
              and innovation. These projects often culminate in demonstrations or competitions, where students 
              can showcase their creations.
            </p>
          </div>

          <div className="roboticslab-feature">
            <h3 className="roboticslab-feature-title">Expert Mentorship:</h3>
            <p className="roboticslab-feature-text">
              Our instructors are not only educators but also passionate technologists who guide students 
              through the complexities of AI and robotics. They provide mentorship and support, encouraging 
              students to explore and innovate.
            </p>
          </div>

          <div className="roboticslab-feature">
            <h3 className="roboticslab-feature-title">Extracurricular Opportunities:</h3>
            <p className="roboticslab-feature-text">
              The lab also serves as a center for robotics clubs, AI workshops, and inter-school competitions, 
              providing students with opportunities to deepen their knowledge and engage with peers who share 
              their interests.
            </p>
          </div>

          <p className="roboticslab-conclusion-text">
            At Bihani Children's Academy, we are committed to equipping our students with the skills they need 
            to excel in a rapidly changing world. Our AI and Robotics Lab is more than just a place to learn; 
            it's a launchpad for the next generation of innovators and thinkers.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RoboticsLab;